// Generated by ts-to-zod
import { z } from 'zod';
import { queueRuleSchema } from '../../../rules/models/queueRule.schema';
import { urlSchema } from '../../../utils/codecUtils.schema';

export const suggestTriggerConditionSummaryPayloadSchema = z.object({
  userQuery: z.string().optional(),
  schemaRule: queueRuleSchema.partial(),
  queue: urlSchema,
});

export const suggestTriggerConditionSummaryResultSchema = z.object({
  triggerCondition: z.string().optional(),
  triggerConditionSummary: z.string().optional(),
});

export const suggestTriggerConditionSummaryResponseSchema = z.object({
  results: z.array(suggestTriggerConditionSummaryResultSchema),
});
